'use strict';

import ready from './lib/ready';
import {mutate} from './lib/promise-fastdom';
import promiseIdle from './lib/promise-idle';
import ToggleArea from './lib/ToggleArea';
import {ButtonBehavior} from './lib/ToggleArea_ButtonBehavior';
import FocusJail from './lib/FocusJail';

ready()
    .then(promiseIdle())
    .then(mutate(function () {

        Array.prototype.map.call(document.querySelectorAll('.overlay[id]'), (overlay => {

            const open = document.querySelector(`a[href="#${overlay.id}"]`);
            const close = overlay.querySelector('.overlay__close');

            const instance = new ToggleArea(overlay, 'overlay', [
                new ButtonBehavior(open, {
                    closeOnLinkClick: false,
                    closeOnOutsideClick: false,
                    focusAreaOnOpen: true,
                    buttons: [close],
                    jail: new FocusJail([overlay]),
                })
            ]);

            return instance.ready();
        }));
    }));